/* eslint-disable complexity */
import { AppState } from 'src/app/store'
import { projectFormSectionHelpers } from './project-form-sections.helpers'

export const projectFormCompletedStepsSelector = (state: AppState): number => {
  const form = state.projects.projectForm
  if (!form.kind) return 0
  let arraySum = []

  /* Definition */
  if (projectFormSectionHelpers.isDefinitionCompleted(form)) {
    arraySum.push(1)
  }

  /* Location */
  if (projectFormSectionHelpers.isLocationCompleted(form)) {
    arraySum.push(1)
  }

  /* Content */
  if (projectFormSectionHelpers.isContentCompelted(form)) {
    arraySum.push(1)
  }

  /* Tax Relief */
  if (projectFormSectionHelpers.isTaxReliefCompleted(form)) {
    arraySum.push(1)
  }

  /* Price and Stock */
  if (projectFormSectionHelpers.isPriceCompleted(form)) {
    arraySum.push(1)
  }

  /* Certifications */
  if (projectFormSectionHelpers.isCertificationsCompleted(form)) {
    arraySum.push(1)
  }

  /* Documentation */
  if (projectFormSectionHelpers.isDocumentationCompleted(form)) {
    arraySum.push(1)
  }

  /* Configuration */
  // this step is always completed, is not required on validations
  arraySum.push(1)

  return arraySum.map(item => item).reduce((prev, curr) => prev + curr, 0)
}
